module.exports = __webpack_public_path__ + "static/media/kr.b1544ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kr.png
// module id = 1900
// module chunks = 0